import { BlurStage } from '../extensions/blur-stage';
import { CustomLayer } from '../extensions/custom-layer';
import { StageData } from './stage-data';

export class StageServer extends StageData {
    /** 自定义图层 */
    customLayer: CustomLayer;
    /** 舞台模糊 */
    blurStage: BlurStage;

    constructor(identity: string) {
        super(identity);
        this.customLayer = new CustomLayer(identity);
        this.blurStage = new BlurStage(identity);
    }

    destroy() {
        super.destroy();
        this.customLayer.destroy();
        this.blurStage.destroy();
    }
}
